import { Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';

import { AdminInput } from './AdminTextField';
import { StepAccordion } from './StepAccordion';

interface TokenConfigurationProps {
  isDisabled?: boolean;
}

export function NodeSystemIntegration({ isDisabled }: TokenConfigurationProps) {
  const {
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext<ProjectInputs>();
  const watchNodeSystem = watch('nodeSystem');

  return (
    <StepAccordion
      isError={!!errors.nodeSystem}
      title={'Core System Deployment'}
      index={9}
      isActive={!!watchNodeSystem?.isDatagramEnabled}
      isHideContent={!watchNodeSystem?.isDatagramEnabled}
      onChangeActive={value => {
        setValue('nodeSystem.isDatagramEnabled', value);
        if (!value) {
          setValue('nodeSystem.email', '');
          clearErrors('nodeSystem.email');
        }
      }}>
      {watchNodeSystem?.isDatagramEnabled && (
        <Stack gap={3}>
          <>
            <Stack gap={3} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
              <Typography fontSize={'14px'} fontWeight={400} color={'white'} lineHeight={'20px'} variant='h6'>
                Deploy and manage your independent Core System seamlessly using LFG’s Core Technology.
              </Typography>
            </Stack>
            <Stack width={'100%'}>
              <Typography paddingBottom={1} color={colors.neutral200} fontSize={'14px'} variant='h6'>
                Contact Email Address
              </Typography>
              <Controller
                name='nodeSystem.email'
                control={control}
                render={({ field }) => (
                  <AdminInput
                    disabled={isDisabled}
                    isError={!!errors?.nodeSystem?.email}
                    errorMsg={errors.nodeSystem?.email?.message}
                    placeholder={'example@email.com'}
                    {...field}
                  />
                )}
              />
              <Typography marginTop={'8px'} color={colors.neutral90} fontSize={'12px'} fontStyle={'italic'}>
                This feature is currently in development. Be the first to access it when it goes live by signing up with
                your email.
              </Typography>
            </Stack>
          </>
        </Stack>
      )}
    </StepAccordion>
  );
}
